export default __webpack_public_path__ + "static/media/GoBolt-Primary-for-Dark-Bg.718aa7b5.png";